<template>
  <div class="page-container">
    <el-collapse v-model="collapseName">
      <el-collapse-item name="baseInfo">
        <template slot="title">
          <span class="header-title">运单基本信息</span>
        </template>
        <el-row :gutter="20" style="padding: 10px 4px">
          <el-col :span="4"
            ><div>
              <span>e集运运单编号</span>
              <p>{{ waybillInfo.waybillNo }}</p>
              <p>{{ waybillInfo.bookingOrderNo }}</p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>陆运帮运单编号</span>
              <p>{{ waybillInfo.cargoBillNo }}</p>
              <p>{{ waybillInfo.lybWaybillNo }}</p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>运单状态</span>
              <p style="color: red">{{ waybillInfo.waybillStatusDesc }}</p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>运单运费结算状态</span>
              <p>
                {{ waybillInfo.settleStatusDesc
                }}<kt-button
                  v-if="waybillInfo.settleStatus === 20"
                  label=""
                  perms="-1"
                  type="text"
                  icon="el-icon-refresh"
                  @click="refreshSettleStatus"
                ></kt-button>
              </p>
              <p style="margin: 0px">
                {{
                  waybillInfo.approvalFailReason
                    ? "失败原因：" + waybillInfo.approvalFailReason
                    : ""
                }}
              </p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>发运主体</span>
              <p v-if="waybillInfo.waybillSettleConfigDto">
                {{ waybillInfo.waybillSettleConfigDto.dispatchSubject }}
              </p>
            </div></el-col
          >
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="4">
            <div>
              <span>车牌号</span>
              <p>{{ waybillInfo.carPlateNo }}</p>
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              <span>司机姓名</span>
              <p>{{ waybillInfo.driverName }}</p>
            </div>
          </el-col>
          <el-col :span="4"
            ><div>
              <span>司机手机号</span>
              <p>{{ waybillInfo.driverPhone }}</p>
            </div></el-col
          >
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="4"
            ><div>
              <span>煤种</span>
              <p>{{ waybillInfo.coalCategoryName }}</p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>煤种单价(元/吨)</span>
              <p v-if="waybillInfo.waybillSettleConfigDto">
                {{ waybillInfo.waybillSettleConfigDto["coalCategoryUnitPrice"]
                }}<kt-button
                  v-if="isShowManualModifyPrice"
                  label=""
                  perms="60523"
                  type="text"
                  icon="el-icon-edit"
                  @click="updateCoalMinePrice"
                ></kt-button>
              </p></div
          ></el-col>
          <el-col :span="4"
            ><div>
              <span>装货地址</span>
              <p>{{ waybillInfo.loadingAddress }}</p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>卸货地址</span>
              <p>{{ waybillInfo.unloadingAddress }}</p>
            </div></el-col
          >
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="4"
            ><div>
              <span>报名时间</span>
              <p>{{ waybillInfo.signUpTime }}<kt-button
                  v-if="waybillInfo.signUpTime && waybillInfo.settleStatus == 40"
                  label=""
                  perms="60523"
                  type="text"
                  icon="el-icon-edit"
                  @click="handleUpdateBillTime('signUpTime',1)"
                ></kt-button></p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>出矿时间</span>
              <p>{{ waybillInfo.outMineTime }}<kt-button
                  v-if="waybillInfo.outMineTime && waybillInfo.settleStatus == 40"
                  label=""
                  perms="60523"
                  type="text"
                  icon="el-icon-edit"
                  @click="handleUpdateBillTime('outMineTime',2)"
                ></kt-button></p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>出站时间</span>
              <p>{{ waybillInfo.outStationTime }}<kt-button
                  v-if="waybillInfo.outStationTime && waybillInfo.settleStatus == 40"
                  label=""
                  perms="60523"
                  type="text"
                  icon="el-icon-edit"
                  @click="handleUpdateBillTime('outStationTime',3)"
                ></kt-button></p>
            </div></el-col
          >
          <el-col :span="4"
            ><div>
              <span>票据时间</span>
              <p>
                {{ waybillInfo.billTime
                }}<kt-button
                  v-if="waybillInfo.billTime && isShowManualModifyPrice"
                  label=""
                  perms="60523"
                  type="text"
                  icon="el-icon-edit"
                  @click="handleUpdateBillTime('billTime',0)"
                ></kt-button>
              </p></div
          ></el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20" v-if="waybillInfo.waybillSettleConfigDto">
          <el-col :span="4">
            <div class="item-info">
              <span>运价(元/吨)：</span>
              <p>{{ waybillInfo.waybillSettleConfigDto.carriageUnitPrice }}</p>
            </div>
            <div class="item-info">
              <span>装货吨位(吨)：</span>
              <p>{{ waybillInfo.waybillSettleConfigDto.loadingTon }}</p>
            </div>
            <div class="item-info">
              <span>卸货吨位(吨)：</span>
              <p>{{ waybillInfo.waybillSettleConfigDto.unloadingTon }}</p>
            </div>
            <div class="item-info">
              <span>允许货损(KG)：</span>
              <p>{{ waybillInfo.waybillSettleConfigDto.allowGoodsDamage }}</p>
            </div>
            <div class="item-info">
              <span>装货费用(元)：</span>
              <p>{{ waybillInfo.waybillSettleConfigDto.loadingFee }}</p>
            </div>
            <div class="item-info">
              <span>卸货费用(元)：</span>
              <p>{{ waybillInfo.waybillSettleConfigDto.unloadingFee }}</p>
            </div>
            <div class="item-info">
              <span>核算吨位方式：</span>
              <p>
                {{
                  tonSettleType[
                    waybillInfo.waybillSettleConfigDto.tonSettleType
                  ]
                }}
              </p>
            </div>
            <div class="item-info">
              <span>抹零方式：</span>
              <p>
                {{
                  roundTypeList.length
                    ? roundTypeList.find((item) => {
                        return (
                          item.codeStr ===
                          waybillInfo.waybillSettleConfigDto.roundType
                        );
                      })["name"]
                    : ""
                }}
              </p>
            </div>
            <div class="item-info">
              <span>手动扣/补款金额(元)：</span>
              <p>{{ waybillInfo.waybillSettleConfigDto.manualModifyPrice }}</p>
            </div>
            <div class="item-info">
              <span>建议运费(元)：</span>
              <span style="color: red">{{
                waybillInfo.waybillSettleConfigDto.suggestCarriage
              }}</span>
            </div>
            <div class="item-info" v-if="waybillInfo.settleStatus === 25">
              <span>实结运费(元)：</span>
              <p style="color: red">{{ waybillInfo.realAmount }}</p>
            </div>
            <div class="item-info">
              <kt-button
                perms="60523"
                label="修改"
                v-if="isShowManualModifyPrice"
                type="primary"
                @click="showUpdateDialog"
              ></kt-button>
              <kt-button
                perms="60524"
                label="手动扣/补款"
                v-if="isShowManualModifyPrice"
                type="danger"
                @click="isShowDealFee = true"
              ></kt-button>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="image-info">
              <div class="item-image">
                <span
                  >矿发图片<el-upload
                    action=""
                    :show-file-list="false"
                    :http-request="uploadImage(1)"
                    ><kt-button
                      v-if="isShowManualModifyPrice"
                      label=""
                      perms="60523"
                      type="text"
                      icon="el-icon-edit"
                    ></kt-button></el-upload
                ></span>
                <el-image
                  v-if="waybillInfo.mineStartImg"
                  :src="waybillInfo.mineStartImg"
                  :preview-src-list="[waybillInfo.mineStartImg]"
                ></el-image>
              </div>
              <div class="item-image">
                <span
                  >到站图片<el-upload
                    action=""
                    :show-file-list="false"
                    :http-request="uploadImage(2)"
                  >
                    <kt-button
                      v-if="isShowManualModifyPrice"
                      label=""
                      perms="60523"
                      type="text"
                      icon="el-icon-edit"
                    ></kt-button> </el-upload
                ></span>
                <el-image
                  v-if="waybillInfo.arriveStationImg"
                  :src="waybillInfo.arriveStationImg"
                  :preview-src-list="[waybillInfo.arriveStationImg]"
                ></el-image>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="4">
            <div>
              <span>结算金额是否矫正</span>
              <p>
                {{ waybillInfo.hasSettlePriceFix ? "是" : "否" }}
              </p>
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              <span>矫正记录</span>
              <p>
                <el-popover placement="right" width="400" trigger="click">
                  <div class="card-content" v-if="adjustLog">
                    <div class="card-title">矫正记录</div>
                    <div class="card-info">
                      <div class="item-desc">
                        <span>建议：</span>
                        <!-- <span>运价：{{ adjustLog.suggestFreight }}元/吨</span>
                        <span
                          >装货吨位：{{ adjustLog.suggestLoadingTon }}吨</span
                        >
                        <span
                          >卸货吨位：{{ adjustLog.suggestUnloadingTon }}吨</span
                        >
                        <span style="display: flex"
                          >建议运费(元)：<span style="color: red">{{
                            adjustLog.suggestCarriage
                          }}</span></span
                        > -->
                        <div
                          v-for="item in adjustLog.beforeJson"
                          :key="item.name"
                          style="display: flex"
                        >
                          <span>{{ item.desc }}：</span>
                          <span>{{ item.value }}{{ unitType[item.name] }}</span>
                        </div>
                      </div>
                      <div class="line"></div>
                      <div class="item-desc">
                        <span>实际：</span>
                        <!-- <span>运价：{{ adjustLog.carriageUnitPrice }}元/吨</span>
                        <span>装货吨位：{{ adjustLog.loadingTon }}吨</span>
                        <span>卸货吨位：{{ adjustLog.unloadingTon }}吨</span>
                        <span style="display: flex"
                          >实结运费(元)：<span style="color: red">{{
                            adjustLog.billfee
                          }}</span></span
                        > -->
                        <div
                          v-for="item in adjustLog.afterJson"
                          :key="item.name"
                          style="display: flex"
                        >
                          <span>{{ item.desc }}：</span>
                          <span v-diff="{ row: adjustLog, key: item.name }">{{
                            item.value + unitType[item.name]
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>结算金额未进行过矫正</div>
                  <el-button type="text" slot="reference" size="mini"
                    >查看</el-button
                  >
                </el-popover>
              </p>
            </div>
          </el-col>
          <el-col :span="4">
            <span>卸货数据上传方式</span>
            <p>
              {{
                waybillInfo.unloadingDataUploadWay
                  ? uploadTypeList.find((item) => {
                      return item.code == waybillInfo.unloadingDataUploadWay;
                    })["name"]
                  : ""
              }}
            </p>
          </el-col>
          <el-col :span="4">
            <span>付款时间</span>
            <p style="color: red">{{ waybillInfo.payTime }}</p>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item name="timeAxis">
        <template slot="title">
          <span class="header-title">操作记录</span>
        </template>
        <div style="padding: 10px 8px">
          <el-timeline v-if="timeAxis.length > 0">
            <el-timeline-item
              v-for="(item, index) in timeAxis"
              :key="index"
              :color="item.color"
              :timestamp="item.operationTime"
            >
              <p>
                {{ item.operationStaffName }} {{ item.operationType }}
                {{
                  operationTypeList.includes(item.operationType)
                    ? "原因：" + item.operationRemark
                    : ""
                }}
                <span
                  v-if="item.modifyBeforeJson && item.modifyAfterJson"
                  style="color: #409eff; cursor: pointer"
                  @click="showUpdateContent(item)"
                  >查看更改内容</span
                >
              </p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!--运费基础信息修改  -->
    <el-dialog
      width="40%"
      v-if="isShowUpdateDialog"
      :visible.sync="isShowUpdateDialog"
      @close="closeSettlementDialog"
      title="运费基础信息修改"
      :lock-scroll="true"
      :close-on-click-modal="false"
    >
      <el-form
        size="small"
        label-width="150px"
        :model="settleForm"
        ref="settleForm"
        :rules="ruleForm"
      >
        <el-form-item label="运价：" prop="carriageUnitPrice">
          <el-input
            v-model="settleForm.carriageUnitPrice"
            class="mini-input"
            type="number"
            oninput="if(value.length>8)value=value.slice(0,8)"
            clearable
            placeholder="请输入运价"
          ></el-input
          >元/吨
        </el-form-item>

        <el-form-item label="装货吨位：" prop="loadingTon">
          <el-input
            v-model.number="settleForm.loadingTon"
            type="number"
            class="mini-input"
            :maxlength="8"
            clearable
            placeholder="请输入装货吨位"
          ></el-input
          >吨
        </el-form-item>
        <el-form-item label="卸货吨位：" prop="unloadingTon">
          <el-input
            v-model.number="settleForm.unloadingTon"
            type="number"
            class="mini-input"
            :maxlength="8"
            clearable
            placeholder="请输入卸货吨位"
          ></el-input
          >吨
        </el-form-item>
        <el-form-item label="允许货损：" prop="allowGoodsDamage">
          <el-input
            v-model.number="settleForm.allowGoodsDamage"
            type="number"
            class="mini-input"
            :maxlength="8"
            clearable
            placeholder="请输入允许货损"
          ></el-input
          >KG
        </el-form-item>
        <el-form-item label="装货费用：" prop="loadingFee">
          <el-input
            v-model.number="settleForm.loadingFee"
            class="mini-input"
            :maxlength="8"
            type="number"
            clearable
            placeholder="请输入装货费用"
          ></el-input
          >元
        </el-form-item>
        <el-form-item label="卸货费用：" prop="unloadingFee">
          <el-input
            v-model.number="settleForm.unloadingFee"
            class="mini-input"
            :maxlength="8"
            type="number"
            clearable
            placeholder="请输入卸货费用"
          ></el-input
          >元
        </el-form-item>
        <el-form-item label="运费核算吨位：" prop="tonSettleType">
          <el-radio-group v-model="settleForm.tonSettleType">
            <el-radio :label="1">装货吨位</el-radio>
            <el-radio :label="2">卸货吨位</el-radio>
            <el-radio :label="3">装、卸最小吨位</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抹零方式：" prop="roundType">
          <el-radio-group v-model="settleForm.roundType">
            <el-radio
              v-for="item in roundTypeList"
              :key="item.codeStr"
              :label="item.codeStr"
              >{{ item.name }}</el-radio
            >
            <!-- <el-radio :label="1">小数抹零</el-radio>
              <el-radio :label="2">个位抹零</el-radio>
              <el-radio :label="3">不抹零</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手动补扣款金额：">
          <span>{{ settleForm.manualModifyPrice }}元</span>
        </el-form-item>
        <el-form-item label="建议运费：">
          <span>{{ suggestCarriage }}元</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="isShowUpdateDialog = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="submitSettleForm"
          >保 存</el-button
        >
      </span>
    </el-dialog>

    <!-- 煤价 修改 -->
    <el-dialog
      :visible.sync="isShowUpdatePrice"
      title="煤价修改"
      :lock-scroll="true"
      @submit.native.prevent
      :close-on-click-modal="false"
      width="400px"
      @close="clearCoalminePrice"
    >
      <el-form label-width="100px" size="mini">
        <el-form-item label="煤价：">
          <el-input
            v-model="coalMinePrice"
            type="number"
            placeholder="请输入修改后的煤价"
            class="mini-input"
            clearable
          ></el-input
          >元/吨
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="isShowUpdatePrice = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="updatePrice"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 手动补扣款 -->
    <el-dialog
      :visible.sync="isShowDealFee"
      title="手动补扣款"
      :lock-scroll="true"
      :close-on-click-modal="false"
      width="400px"
      @close="clearFeeForm"
    >
      <el-form
        label-width="100px"
        size="mini"
        :model="dealFeeForm"
        :rules="feeForm"
        ref="dealFeeForm"
      >
        <el-form-item label="补扣类型：" prop="type">
          <el-radio-group v-model="dealFeeForm.type">
            <el-radio label="1">补款</el-radio>
            <el-radio label="2">扣款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="补扣金额：" prop="fee">
          <el-input
            v-model="dealFeeForm.fee"
            type="number"
            placeholder="请输入补扣金额"
            class="mini-input"
            clearable
          ></el-input
          >元
        </el-form-item>
        <el-form-item label="补扣原因：" prop="reason">
          <el-input
            v-model="dealFeeForm.reason"
            type="textarea"
            placeholder="请输入原因"
            show-word-limit
            :maxlength="30"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="isShowDealFee = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitFeeForm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 变更记录修改 三种 运单信息 矿发、到站图 -->
    <el-dialog
      :visible.sync="isShowUpdateContent"
      v-if="isShowUpdateContent"
      :title="contentTitle"
      width="500px"
      :lock-scroll="true"
      :close-on-click-modal="false"
    >
      <div class="change-info">
        <div class="change-item">
          <span style="margin-bottom: 10px">变更前：</span>
          <div v-if="curUpdateContent.type == 1" style="padding: 10px">
            <div class="item-content">
              <p>运价：</p>
              <p>
                {{ curUpdateContent.beforeJson.carriageUnitPrice || 0 }}元/吨
              </p>
            </div>
            <div class="item-content">
              <p>装货吨位：</p>
              <p>{{ curUpdateContent.beforeJson.loadingTon || 0 }}吨</p>
            </div>
            <div class="item-content">
              <p>卸货吨位：</p>
              <p>{{ curUpdateContent.beforeJson.unloadingTon || 0 }}吨</p>
            </div>
            <div class="item-content">
              <p>煤种单价：</p>
              <p>
                {{
                  curUpdateContent.beforeJson.coalCategoryUnitPrice || 0
                }}元/吨
              </p>
            </div>
            <div class="item-content">
              <p>允许货损：</p>
              <p>{{ curUpdateContent.beforeJson.allowGoodsDamage || 0 }}KG</p>
            </div>
            <div class="item-content">
              <p>装货费用：</p>
              <p>{{ curUpdateContent.beforeJson.loadingFee || 0 }}元</p>
            </div>
            <div class="item-content">
              <p>卸货费用：</p>
              <p>{{ curUpdateContent.beforeJson.unloadingFee || 0 }}元</p>
            </div>
            <div class="item-content">
              <p>核算吨位方式：</p>
              <p>
                {{ tonSettleType[curUpdateContent.beforeJson.tonSettleType] }}
              </p>
            </div>
            <div class="item-content">
              <p>抹零方式：</p>
              <p>
                {{
                  roundTypeList.length
                    ? roundTypeList.find((item) => {
                        return (
                          item.codeStr === curUpdateContent.beforeJson.roundType
                        );
                      })["name"]
                    : ""
                }}
              </p>
            </div>
            <div class="item-content">
              <p>手动补/扣款：</p>
              <p>{{ curUpdateContent.beforeJson.manualModifyPrice }}元</p>
            </div>
          </div>
          <div v-else-if="curUpdateContent.type == 2" style="padding: 10px">
            <el-image
              v-if="curUpdateContent.beforeJson[0]['value']"
              :src="curUpdateContent.beforeJson[0]['value']"
              :preview-src-list="[curUpdateContent.beforeJson[0]['value']]"
            ></el-image>
          </div>
          <div v-else-if="curUpdateContent.type == 3" style="padding: 10px">
            <div
              v-for="item in curUpdateContent.beforeJson"
              :key="item.name"
              style="display: flex"
            >
              <span>{{ item.desc }}：</span>
              <span>{{ item.value }}{{ unitType[item.name] }}</span>
            </div>
          </div>
        </div>
        <div class="change-item">
          <span style="margin-bottom: 10px">变更后：</span>
          <div v-if="curUpdateContent.type == 1" style="padding: 10px">
            <div class="item-content">
              <p>运价：</p>
              <p v-diff="{ row: curUpdateContent, key: 'carriageUnitPrice' }">
                {{ curUpdateContent.afterJson.carriageUnitPrice || "" }}元/吨
              </p>
            </div>
            <div class="item-content">
              <p>装货吨位：</p>
              <p v-diff="{ row: curUpdateContent, key: 'loadingTon' }">
                {{ curUpdateContent.afterJson.loadingTon || "" }}吨
              </p>
            </div>
            <div class="item-content">
              <p>卸货吨位：</p>
              <p v-diff="{ row: curUpdateContent, key: 'unloadingTon' }">
                {{ curUpdateContent.afterJson.unloadingTon || "" }}吨
              </p>
            </div>
            <div class="item-content">
              <p>煤种单价：</p>
              <p
                v-diff="{ row: curUpdateContent, key: 'coalCategoryUnitPrice' }"
              >
                {{
                  curUpdateContent.afterJson.coalCategoryUnitPrice || ""
                }}元/吨
              </p>
            </div>
            <div class="item-content">
              <p>允许货损：</p>
              <p v-diff="{ row: curUpdateContent, key: 'allowGoodsDamage' }">
                {{ curUpdateContent.afterJson.allowGoodsDamage || 0 }}KG
              </p>
            </div>
            <div class="item-content">
              <p>装货费用：</p>
              <p v-diff="{ row: curUpdateContent, key: 'loadingFee' }">
                {{ curUpdateContent.afterJson.loadingFee || 0 }}元
              </p>
            </div>
            <div class="item-content">
              <p>卸货费用：</p>
              <p v-diff="{ row: curUpdateContent, key: 'unloadingFee' }">
                {{ curUpdateContent.afterJson.unloadingFee || 0 }}元
              </p>
            </div>
            <div class="item-content">
              <p>核算吨位方式：</p>
              <p v-diff="{ row: curUpdateContent, key: 'tonSettleType' }">
                {{ tonSettleType[curUpdateContent.afterJson.tonSettleType] }}
              </p>
            </div>
            <div class="item-content">
              <p>抹零方式：</p>
              <p v-diff="{ row: curUpdateContent, key: 'roundType' }">
                {{
                  roundTypeList.length
                    ? roundTypeList.find((item) => {
                        return (
                          item.codeStr === curUpdateContent.afterJson.roundType
                        );
                      })["name"]
                    : ""
                }}
              </p>
            </div>
            <div class="item-content">
              <p>手动补/扣款：</p>
              <p v-diff="{ row: curUpdateContent, key: 'manualModifyPrice' }">
                {{ curUpdateContent.afterJson.manualModifyPrice }}元
              </p>
            </div>
          </div>
          <div v-else-if="curUpdateContent.type == 2" style="padding: 10px">
            <el-image
              v-if="curUpdateContent.afterJson[0]['value']"
              :src="curUpdateContent.afterJson[0]['value']"
              :preview-src-list="[curUpdateContent.afterJson[0]['value']]"
            ></el-image>
          </div>
          <div v-else-if="curUpdateContent.type == 3" style="padding: 10px">
            <div
              v-for="item in curUpdateContent.afterJson"
              :key="item.name"
              style="display: flex"
            >
              <span>{{ item.desc }}：</span>
              <span v-diff="{ row: curUpdateContent, key: item.name }"
                >{{ item.value }}{{ unitType[item.name] }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class=""></div>
    </el-dialog>

    <!-- 票据时间 -->
    <el-dialog
      :visible.sync="isShowBillTime"
      v-if="isShowBillTime"
      width="500px"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :title="'修改'+updateTimeTitle"
    >
      <div style="margin-left: 20px">
        <span>{{updateTimeTitle}}：</span>
        <el-date-picker
          v-model="updateTime"
          size="small"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择票据时间"
        >
        </el-date-picker>
      </div>
      <span slot="footer">
        <el-button size="small" @click="isShowBillTime = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitBillTime"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>


<script>
import KtButton from "@/components/Core/KtButton";
import global from "@/utils/global";
import {
  dispatchSubject,
  tonSettleType,
  unitType,
  operationTypeList,
  uploadTypeList,
} from "@/utils/instance.js";
let channel;
export default {
  data() {
    return {
      collapseName: ["baseInfo", "timeAxis"],
      timeAxis: [],
      dispatchSubject,
      waybillInfo: {},
      isShowUpdateDialog: false,
      settleForm: {},
      isShowUpdatePrice: false,
      coalMinePrice: "",
      isShowDealFee: false,
      dealFeeForm: {
        type: "",
        fee: "",
        reason: "",
      },
      uploadTypeList,
      operationTypeList,
      tonSettleType,
      roundTypeList: [],
      curUpdateContent: "",
      feeForm: {
        type: [{ required: true, message: "请选择补扣类型" }],
        fee: [{ required: true, validator: this.checkFee() }],
        reason: [{ required: true, message: "请填写补扣原因" }],
      },
      ruleForm: {
        carriageUnitPrice: [{ required: true, message: "请输入运价" }],
        loadingTon: [
          {
            required: true,
            message: "请输入装货吨位",
            validator: this.checkAllowsGoodsDamage("loadingTon"),
          },
        ],
        unloadingTon: [
          {
            required: true,
            message: "请输入卸货吨位",
            validator: this.checkAllowsGoodsDamage("unloadingTon"),
          },
        ],
        allowGoodsDamage: [
          {
            required: true,
            validator: this.checkAllowsGoodsDamage("allowGoodsDamage"),
          },
        ],
        loadingFee: [{ required: true, message: "请输入装货费费用" }],
        unloadingFee: [{ required: true, message: "请输入卸货费用" }],
        tonSettleType: [{ required: true, message: "请选择核算吨位方式" }],
        roundType: [{ required: true, message: "请选择抹零方式" }],
      },
      contentTitle: "",
      adjustLog: {},
      isShowUpdateContent: false,
      // uploadUrl:global.baseUrl + '/admin/file/uploadImage'
      unitType,
      isShowBillTime: false,
      updateTime: null,
      updateTimeTitle:'',
      updateTimeAction:''
    };
  },
  components: {
    KtButton,
  },
  computed: {
    suggestCarriage() {
      let {
        carriageUnitPrice,
        loadingTon,
        unloadingTon,
        allowGoodsDamage,
        loadingFee,
        unloadingFee,
        tonSettleType,
        roundType,
        manualModifyPrice,
      } = this.settleForm;
      let { coalCategoryUnitPrice } = this.waybillInfo.waybillSettleConfigDto;
      let goodsDamageTemp =
        (loadingTon * 100000 - unloadingTon * 100000 - allowGoodsDamage * 100) /
        100000;
      let goodsDamage = goodsDamageTemp > 0 ? goodsDamageTemp : 0;
      // console.log(goodsDamage)
      let ton;
      if (tonSettleType === 1) {
        ton = loadingTon;
      } else if (tonSettleType === 2) {
        ton = unloadingTon;
      } else {
        ton = loadingTon < unloadingTon ? loadingTon : unloadingTon;
      }

      let finailyFee =
        (carriageUnitPrice * ton * 100000 -
          goodsDamage * coalCategoryUnitPrice * 100000 +
          manualModifyPrice * 100000 -
          loadingFee * 100000 -
          unloadingFee * 100000) /
        100000;
      // console.log(ton, finailyFee);
      if (roundType === 2) {
        finailyFee = Math.floor(finailyFee);
      } else if (roundType === 1) {
        finailyFee = Math.floor(finailyFee / 10) * 10;
      } else {
        finailyFee = finailyFee.toFixed(2);
      }
      // console.log(finailyFee)
      return isNaN(finailyFee) ? 0 : finailyFee;
    },
    isShowManualModifyPrice() {
      let autharr = [5, 10, 15, 35, 40];
      return autharr.includes(this.waybillInfo.settleStatus);
    },
  },
  mounted() {
    channel = new BroadcastChannel("update-child-info");
    this.getWaybillInfo();
    this.getRoundTypeList();
    this.getAdjustLog();
    this.getTimeAxis();
  },
  methods: {
    //刷新运单运费结算状态
    async getRoundTypeList() {
      let result = await this.$api.apply.mGetRoundTypeList();
      result.data.forEach((item) => {
        item.codeStr = Number(item.codeStr);
      });
      this.roundTypeList = result.data;
    },
    async refreshSettleStatus() {
      if (!this.waybillInfo.lybWaybillNo) {
        this.$message({
          type: "error",
          message: "无陆运帮运单编号！",
          offset: 300,
        });
        return;
      }
      await this.$api.finance.refreshStatus({
        waybillNo: this.$route?.query?.id,
        lybWaybillNo: this.waybillInfo.lybWaybillNo,
      });
      this.getWaybillInfo();
      this.getAdjustLog();
      this.getTimeAxis();
    },
    closeSettlementDialog() {
      this.$refs.settleForm.resetFields();
    },
    submitSettleForm() {
      this.$refs.settleForm.validate((valid) => {
        this.$loading();
        if (valid) {
          this.$api.finance
            .updateBaseInfo({
              ...this.settleForm,
              waybillNo: this.$route?.query?.id,
            })
            .then((res) => {
              this.$loading().close();
              this.$message({
                type: "success",
                message: "修改成功",
                offset: 300,
              });
              this.isShowUpdateDialog = false;
              this.getWaybillInfo();
              this.getTimeAxis();
              channel.postMessage("update");
            });
        }
      });
    },
    showUpdateDialog() {
      let {
        carriageUnitPrice,
        loadingTon,
        unloadingTon,
        allowGoodsDamage,
        loadingFee,
        unloadingFee,
        tonSettleType,
        roundType,
        manualModifyPrice,
      } = this.waybillInfo.waybillSettleConfigDto;

      this.settleForm = {
        carriageUnitPrice,
        loadingTon,
        unloadingTon,
        allowGoodsDamage,
        loadingFee,
        unloadingFee,
        tonSettleType,
        roundType,
        manualModifyPrice,
      };
      this.isShowUpdateDialog = true;
    },
    async getWaybillInfo() {
      this.$loading();
      let res = await this.$api.finance.mGetSettleDetail({
        waybillNo: this.$route?.query?.id,
      });
      this.$loading().close();
      this.waybillInfo = res.data;
      this.waybillInfo.billTime = res.data.billTime
        ? res.data.billTime.length < 18
          ? res.data.billTime + ":00"
          : res.data.billTime
        : null;
    },
    checkFee() {
      return (rule, value, callback) => {
        // console.log(value)/
        if (!value) {
          return callback(new Error("请填写补扣款金额"));
        }
        this.dealFeeForm.fee = value.match(/^\d*(\.?\d{0,2})/g)[0];
        return callback();
      };
    },
    checkAllowsGoodsDamage(key) {
      return (rule, value, callback) => {
        if (value !== 0 && !value) {
          return callback(new Error("请输入允许货损"));
        }
        this.settleForm[key] = (value + "").match(/^\d*(\.?\d{0,2})/g)[0];
        return callback();
      };
    },
    getAdjustLog() {
      // this.timeAxis =
      this.$api.finance
        .mGetModifyRecord({
          waybillNo: this.$route?.query?.id,
        })
        .then((res) => {
          this.adjustLog = res.data;
          if (!res.data) return;
          this.adjustLog.beforeJson = res.data.modifyBeforeJson
            ? JSON.parse(res.data.modifyBeforeJson)
            : "";
          this.adjustLog.afterJson = res.data.modifyAfterJson
            ? JSON.parse(res.data.modifyAfterJson)
            : "";
        });
    },
    updateCoalMinePrice() {
      this.coalMinePrice =
        this.waybillInfo.waybillSettleConfigDto?.coalCategoryUnitPrice;
      this.isShowUpdatePrice = true;
    },
    uploadImage(imageType) {
      return async (data) => {
        // console.log(data,imageType)
        this.$loading();
        const formData = new FormData();
        formData.append("file", data.file);
        let res = await this.$api.bossMgt.uploadImage(formData);
        // console.log(res)
        this.$api.finance
          .updateImage({
            waybillNo: this.$route?.query?.id,
            imageType,
            imageUrl: res.data.imgUrl,
          })
          .then((result) => {
            this.$loading().close();
            this.$message({
              type: "success",
              message: `修改${imageType == 1 ? "矿发" : "到站"}图片成功`,
              offset: 300,
            });
            this.getWaybillInfo();
            this.getTimeAxis();
          })
          .catch((err) => {});
      };
    },
    clearCoalminePrice() {
      this.coalMinePrice = "";
    },
    clearFeeForm() {
      this.$refs.dealFeeForm.resetFields();
    },
    updatePrice() {
      if (!this.coalMinePrice) {
        this.$message({
          type: "error",
          message: "请输入修改后的煤价",
          offset: 300,
        });
        return;
      }
      this.$api.finance
        .updateCoalMinePrice({
          waybillNo: this.$route?.query?.id,
          mineUnitPrice: this.coalMinePrice,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "修改成功",
            offset: 300,
          });
          this.isShowUpdatePrice = false;
          this.getWaybillInfo();
          this.getTimeAxis();
        });
    },
    submitFeeForm() {
      this.$refs.dealFeeForm.validate((valid) => {
        if (valid) {
          this.$loading();
          this.$api.finance
            .manualModifyPrice({
              waybillNo: this.$route?.query?.id,
              manualModifyPrice:
                this.dealFeeForm.type == 1
                  ? this.dealFeeForm.fee
                  : -this.dealFeeForm.fee,
              manualModifyPriceReason: this.dealFeeForm.reason,
            })
            .then((res) => {
              this.$loading().close();
              this.$message({
                type: "success",
                message: "设置成功",
                offset: 300,
              });
              this.isShowDealFee = false;
              this.getWaybillInfo();
              this.getTimeAxis();
            });
        }
      });
    },
    //获取运单时间轴
    getTimeAxis() {
      let params = {
        pageNo: 1,
        pageSize: 1000,
        operationModule: 16,
      };
      params["searchFieldList[0].fieldName"] = "dataPk";
      params["searchFieldList[0].singleValue"] = this.$route?.query?.id;
      this.$api.finance.mGetLogList(params).then((res) => {
        this.timeAxis = res.data.dtoList || [];
      });
    },
    showUpdateContent(item) {
      let type;
      this.contentTitle = "运单运费变更记录";
      type = 1;
      if (item.modifyBeforeJson.includes("mineSendImgUrl")) {
        this.contentTitle = "矿发图片变更记录";
        type = 2;
      }
      if (item.modifyBeforeJson.includes("arriveStationImgUrl")) {
        this.contentTitle = "到站图片变更记录";
        type = 2;
      }
      if (item.operationRemark.includes("矫正")) {
        this.contentTitle = "运费矫正";
        type = 3;
      }
      this.curUpdateContent = {
        afterJson: item.modifyAfterJson ? JSON.parse(item.modifyAfterJson) : "",
        beforeJson: item.modifyBeforeJson
          ? JSON.parse(item.modifyBeforeJson)
          : "",
        type,
      };
      this.isShowUpdateContent = true;
    },
    handleUpdateBillTime(type,action) {
      this.updateTime = this.waybillInfo[type];
      let obj = {0:'票据时间' ,1:'报名时间' ,2:'出矿时间' ,3:'出站时间'}
      this.updateTimeTitle = `${obj[action]}`
      this.updateTimeAction = action
      this.isShowBillTime = true;
    },
    submitBillTime() {
      this.$api.finance
        .updateTime({
          type: this.updateTimeAction,
          updateTime: this.updateTime,
          waybillNo: this.$route?.query?.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: `更改${this.updateTimeTitle}成功！`,
            offset: 300,
          });
          this.updateTimeAction = ''
          this.updateTimeTitle = ''
          this.isShowBillTime = false;
          this.getWaybillInfo();
          this.getTimeAxis();
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.page-container{
  padding: 10px;
}
::v-deep .el-divider--horizontal {
  margin: 10px 0;
}
.header {
  padding: 10px 0;
}
.header-title {
  padding-left: 10px;
  font-size: 16px;
  font-weight: bold;
}
::v-deep .el-collapse-item__header {
  background: #eee;
  border-radius: 10px;
}
.mini-input {
  width: 150px;
}
.item-info {
  display: flex;
  align-items: center;
  margin: 4px 0;
  p {
    margin: 0;
  }
}
.el-image {
  width: 100%;
  height: 150px;
}
.image-info {
  .item-image {
    span {
      display: flex;
    }
  }
}
.card-content {
  width: 100%;
  .card-title {
    font-size: 20px;
    font-weight: bold;
  }
  .card-info {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item-desc {
      width: 40%;
      span {
        display: block;
      }
    }
    .line {
      width: 1px;
      height: 100px;
      background: #000;
    }
  }
}
.change-info {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  .change-item {
    width: 50%;
    .item-content {
      width: 100%;
      display: flex;
      p {
        margin: 6px 0;
      }
    }
  }
}
</style>